// Who may open a factura in the editor — the same rules as the server (`editableOnly` in backend/routes/invoices.js, which
// re-checks everything): one not yet sent to DGII (borrador / Lista; a sales user's not while it waits for an admin's approval),
// and — admins only, and only while Protocolo 514 is on (its marks and actions exist only then) — an issued internal factura
// with no cobros. Never a note, nor anything DGII has.
export const issuedInternal = (inv) => !!inv?.internal && !inv.ncf && inv.status === 'issued';

export function canEditInvoice(inv, { isAdmin, protocolOn }) {
  if (!inv || inv.modifiesInvoice || inv.legacy?.source) return false;
  if (['draft', 'ready'].includes(inv.status)) return isAdmin || inv.sendApproval?.status !== 'requested';
  return !!(isAdmin && protocolOn && issuedInternal(inv) && inv.ecf?.status !== 'pending' && !(inv.amountPaid > 0.005));
}
